import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import objectAssign from 'object-assign';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { updateSupportContact, changeSupportContact } from '../../../../actions/waitingArea.js';
import { set } from 'lodash';

export default function CenterPanelUpdate(props) {
  const dispatch = useDispatch();
  const [activeElementName, setActiveElementName] = useState(null);
  const [moreAssistanceMessageCharsLeft, setMoreAssistanceMessageCharsLeft] = useState(
    200 - props.supportContactForm.moreAssistance.substr(0, 200).length
  );
  const [maxChars, setMaxChars] = useState(200);
  const [hideTextAreaCaption, setHideTextAreaCaption] = useState();

  useEffect(() => {
    setHideTextAreaCaption(isEmpty(props.supportContactForm.moreAssistance) ? 'hidden' : 'visible');
  }, []);
  // In order to avoid input field lose focus when placeholder is changed
  const getFocusedInputFieldName = () => {
    setActiveElementName(document.activeElement.name);
  };

  const isEmpty = (value) => {
    if (value) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    let isFormEmpty =
      isEmpty(props.supportContactForm.supportName) &&
      isEmpty(props.supportContactForm.supportEmail) &&
      isEmpty(props.supportContactForm.supportPhone) &&
      isEmpty(props.supportContactForm.supportWebsite);

    if (
      isFormEmpty == false &&
      ['supportName', 'supportEmail', 'supportPhone', 'supportWebsite'].includes(activeElementName) >= 0
    ) {
      let callback = () => {
        window.$(`input[name=${activeElementName}]`).focus();
      };
      setTimeout(callback, 50);
    }
  }, [props.supportContactForm]);
  useEffect(() => {
    document.addEventListener('focus', textAreaOnFocusHandler, true);
    document.addEventListener('blur', textAreaOnBlurHandler, true);

    return () => {
      document.removeEventListener('focus', textAreaOnFocusHandler);
      document.removeEventListener('blur', textAreaOnBlurHandler);
    };
  }, []);

  const textAreaOnFocusHandler = () => {
    setHideTextAreaCaption('visible');
  };

  const textAreaOnBlurHandler = () => {
    if (isEmpty(props.supportContactForm.moreAssistance)) {
      setHideTextAreaCaption('hidden');
    }
  };

  const changeInputField = (value, entryName) => {
    let updatedSupportContactForm = {};
    switch (entryName) {
      case 'supportName':
        updatedSupportContactForm = {
          ...props.supportContactForm,
          supportName: value,
        };
        break;
      case 'supportEmail':
        updatedSupportContactForm = {
          ...props.supportContactForm,
          supportEmail: value,
        };
        break;
      case 'supportPhone':
        updatedSupportContactForm = {
          ...props.supportContactForm,
          supportPhone: value,
        };
        break;
      case 'supportWebsite':
        updatedSupportContactForm = {
          ...props.supportContactForm,
          supportWebsite: value,
        };
        break;
    }
    dispatch(changeSupportContact(updatedSupportContactForm));
  };

  let formWithoutValidation = (
    <div>
      <div className="bold title-sms">{APP.LANGUAGE.SupportContactModal.SupportInfoForProviders}</div>
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportNameEdit}
      </div>
      <Txt
        tabIndex="1"
        focusme="true"
        name="supportName"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportNameEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportName')}
        placeholder={`${props.supportContactForm.organisaionSupportName || 'Not provided'} (default)`}
        value=""
        noTitle
      />
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportEmailEdit}
      </div>
      <Txt
        tabIndex="1"
        name="supportEmail"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportEmailEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportEmail')}
        placeholder={`${props.supportContactForm.organisaionSupportEmail || 'Not provided'} (default)`}
        value=""
        noTitle
      />
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportTelEdit}
      </div>
      <Txt
        tabIndex="1"
        name="supportPhone"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportTelEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportPhone')}
        placeholder={`${props.supportContactForm.organisaionSupportPhone || 'Not provided'} (default)`}
        value=""
        noTitle
      />
      <div className="placeholder-label no-bold div-like color-placeholder mrtxs">
        {APP.LANGUAGE.SupportContactModal.SupportWebsiteEdit}
      </div>
      <Txt
        tabIndex="1"
        name="supportWebsite"
        notRenderPlaceholderAsTitle={true}
        titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportWebsiteEdit}
        onKeyPress={getFocusedInputFieldName}
        onChange={(value) => changeInputField(value, 'supportWebsite')}
        placeholder={`${props.supportContactForm.organisaionSupportWebsite || 'Not provided'} (default)`}
        value=""
        noTitle
      />
    </div>
  );
  let formWithValidation = (
    <div>
      <div className="bold title-sms">{APP.LANGUAGE.SupportContactModal.SupportInfoForProviders}</div>
      <ValidMe validmefor="required" group="supportContactModal">
        <Txt
          tabIndex="1"
          focusme="true"
          name="supportName"
          focusme={!!!activeElementName}
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportNameEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportName')}
          placeholder={APP.LANGUAGE.SupportContactModal.SupportNameEdit}
          value={props.supportContactForm.supportName}
          noTitle
        />
      </ValidMe>
      <ValidMe validmefor="email" group="supportContactModal">
        <Txt
          tabIndex="1"
          name="supportEmail"
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportEmailEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportEmail')}
          placeholder={APP.LANGUAGE.SupportContactModal.SupportEmailEdit}
          value={props.supportContactForm.supportEmail}
          noTitle
        />
      </ValidMe>
      <ValidMe validmefor="phoneNumber@emptyok&possibleNumber" group="supportContactModal">
        <Txt
          tabIndex="1"
          name="supportPhone"
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportTelEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportPhone')}
          placeholder={APP.LANGUAGE.SupportContactModal.SupportTelEdit}
          value={props.supportContactForm.supportPhone}
          noTitle
        />
      </ValidMe>
      <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="supportContactModal">
        <Txt
          tabIndex="1"
          name="supportWebsite"
          notRenderPlaceholderAsTitle={false}
          titlePlaceholder={APP.LANGUAGE.SupportContactModal.SupportWebsiteEdit}
          onKeyPress={getFocusedInputFieldName}
          onChange={(value) => changeInputField(value, 'supportWebsite')}
          placeholder={APP.LANGUAGE.SupportContactModal.SupportWebsiteEdit}
          value={props.supportContactForm.supportWebsite}
          noTitle
        />
      </ValidMe>
    </div>
  );
  let validationForm = props.defaultValueIsPicked === true ? formWithoutValidation : formWithValidation;
  return <div className="ui form mrbxl">{validationForm}</div>;
}
